import React from 'react';
import { EmptyState, EmptyStateProps, Box } from '@wix/design-system';

export const GridEmptyState = (props: EmptyStateProps) => (
  <Box direction="vertical" padding="SP7">
    <EmptyState {...props} />
  </Box>
);
